import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  makeStyles,
  Menu,
  MenuItem,
} from "@material-ui/core";

import { Link, useHistory, useLocation } from "react-router-dom";
import MenuIcon from "@material-ui/icons/Menu";
import miniHeader from "../images/miniHeader.png";

import headerIsthia from "../images/headerIsthia.png";

const useStyles = makeStyles((theme) => ({
  Header: {
    backgroundImage: `url(${miniHeader})`,
    height: "12vh",
    backgroundPosition: "center",
    backgroundSize: "cover",
    boxShadow: "none",
  },
  burgerIcon: {
    color: "white",
    height: 40,
    width: 40,
    marginLeft: "2vw",
  },
}));

const Header = () => {
  const history = useHistory();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const classes = useStyles();
  const location = useLocation();

  // Si toute autre page que celle d'accueil, on affiche le header
  // Sinon, on affiche une div vide, pour respecter la template du parent
  if (location.pathname !== "/") {
    return (
      <AppBar position="static" className={classes.Header}>
        <Toolbar>
          <IconButton
            id="basic-button"
            aria-controls={open ? "basic-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={handleClick}
            edge="start"
          >
            <MenuIcon className={classes.burgerIcon} />
          </IconButton>
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}
          >
            <MenuItem
              onClick={() => {
                history.push(`/decouvrir`);
              }}
            >
              Découvrir le projet
            </MenuItem>
            <MenuItem
              onClick={() => {
                history.push(`/pourquoi`);
              }}
            >
              Pourquoi participer ?
            </MenuItem>
            <MenuItem
              onClick={() => {
                history.push(`/mentions-legales`);
              }}
            >
              Mentions légales
            </MenuItem>
            <MenuItem
              onClick={() => {
                history.push(`/politique-cookies`);
              }}
            >
              Politique de cookies
            </MenuItem>
            <MenuItem
              onClick={() => {
                history.push(`/politique-confidentialite`);
              }}
            >
              Politique de confidentialité
            </MenuItem>
          </Menu>
          <img
            src={headerIsthia}
            alt="logo du projet Naturr"
            style={{ width: "60vw", maxWidth: 260 }}
          />
        </Toolbar>
      </AppBar>
    );
  } else {
    return <div></div>;
  }
};

export default Header;
